/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step2_Connect_RedirectInputs */



/**
* | output |
* | --- |
* | "You'll be redirected to authorize access" |
*
* @param {Spaces_Wizard_Step2_Connect_RedirectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step2_connect_redirect = /** @type {((inputs?: Spaces_Wizard_Step2_Connect_RedirectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step2_Connect_RedirectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du wirst weitergeleitet, um den Zugriff zu autorisieren")
	return /** @type {LocalizedString} */ ("You'll be redirected to authorize access")
});